import React, { useState, useEffect } from 'react';
import { Swipeable } from 'react-swipeable';
import styled, { css } from 'styled-components';
import { getSlideAnimation } from 'web-ui-kit/animations/slide';
import NavButton from 'web-ui-kit/buttons/NavButton';
import { grayLightM, selectedM } from 'web-ui-kit/colors';
import ProductImage from 'web-ui-kit/ProductDetails/components/ProductImage';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
/**
 * A 1x1 aspect ratio image carousel.
 *
 * The number of images and currently visible image is indicated by dots.
 *
 * The visible image is updated by:
 *  1. swipping left or right on a touch device
 *  2. clicking on the left or right buttons
 */


function StackedProductImageCarousel(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$dislikeButtonCon = _ref.dislikeButtonConfig,
      dislikeButtonConfig = _ref$dislikeButtonCon === void 0 ? 'hover' : _ref$dislikeButtonCon,
      _ref$likeDislikeEnabl = _ref.likeDislikeEnabled,
      likeDislikeEnabled = _ref$likeDislikeEnabl === void 0 ? false : _ref$likeDislikeEnabl,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$mqTwoColumnUp = _ref.mqTwoColumnUp,
      mqTwoColumnUp = _ref$mqTwoColumnUp === void 0 ? '' : _ref$mqTwoColumnUp,
      _ref$parentProductId = _ref.parentProductId,
      parentProductId = _ref$parentProductId === void 0 ? undefined : _ref$parentProductId,
      _ref$product = _ref.product,
      product = _ref$product === void 0 ? {} : _ref$product,
      _ref$setProductImageE = _ref.setProductImageEl,
      setProductImageEl = _ref$setProductImageE === void 0 ? function () {} : _ref$setProductImageE;
  var _product$images = product.images,
      images = _product$images === void 0 ? [''] : _product$images; // We will manage the current slide state internally.

  var _useState = useState({
    animateDirection: '',
    currentImageIndex: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      carouselState = _useState2[0],
      setCarouselState = _useState2[1];

  var animateDirection = carouselState.animateDirection,
      currentImageIndex = carouselState.currentImageIndex;
  var currentImage = images[currentImageIndex];
  var prevIndex = currentImageIndex > 0 ? currentImageIndex - 1 : images.length - 1;
  var prevImage = images[prevIndex];
  var nextIndex = (currentImageIndex + 1) % images.length;
  var nextImage = images[nextIndex]; // Reset animation state post animation.

  useEffect(function () {
    if (animateDirection) {
      setTimeout(function () {
        setCarouselState(_objectSpread2(_objectSpread2({}, carouselState), {}, {
          animateDirection: ''
        }));
      }, ANIMATION_DURATION_MS);
    }
  }, [animateDirection]); // Handle carousel navigation events.

  var handleNextImageClicked = function handleNextImageClicked() {
    setCarouselState({
      animateDirection: 'next',
      currentImageIndex: nextIndex
    });
  };

  var handlePreviousImageClicked = function handlePreviousImageClicked() {
    setCarouselState({
      animateDirection: 'previous',
      currentImageIndex: prevIndex
    });
  };

  var Animated = styles.Animated,
      Container = styles.Container,
      Dot = styles.Dot,
      Dots = styles.Dots,
      MainProductImage = styles.MainProductImage,
      NextImageButton = styles.NextImageButton,
      OffscreenProductImage = styles.OffscreenProductImage,
      PreviousImageButton = styles.PreviousImageButton;
  return (
    /*#__PURE__*/
    React.createElement(Swipeable, {
      onSwipedLeft: handleNextImageClicked,
      onSwipedRight: handlePreviousImageClicked
    },
    /*#__PURE__*/
    React.createElement(Container, {
      className: className,
      "data-testid": "stacked-carousel"
    }, animateDirection === 'previous' &&
    /*#__PURE__*/
    React.createElement(Animated, {
      animation: getSlideAnimation({
        animateDirection: animateDirection,
        isCurrentImage: false
      })
    },
    /*#__PURE__*/
    React.createElement(MainProductImage, {
      dislikeButtonConfig: dislikeButtonConfig,
      dispatch: dispatch,
      image: nextImage,
      likeDislikeConfig: {
        enabled: likeDislikeEnabled
      },
      mqTwoColumnUp: mqTwoColumnUp,
      parentProductId: parentProductId,
      product: product
    })), animateDirection === 'next' &&
    /*#__PURE__*/
    React.createElement(Animated, {
      animation: getSlideAnimation({
        animateDirection: animateDirection,
        isCurrentImage: false
      })
    },
    /*#__PURE__*/
    React.createElement(MainProductImage, {
      dislikeButtonConfig: dislikeButtonConfig,
      dispatch: dispatch,
      image: prevImage,
      likeDislikeConfig: {
        enabled: likeDislikeEnabled
      },
      mqTwoColumnUp: mqTwoColumnUp,
      parentProductId: parentProductId,
      product: product
    })),
    /*#__PURE__*/
    React.createElement(Animated, {
      animation: getSlideAnimation({
        animateDirection: animateDirection,
        isCurrentImage: true
      })
    },
    /*#__PURE__*/
    React.createElement(MainProductImage, {
      dislikeButtonConfig: dislikeButtonConfig,
      dispatch: dispatch,
      image: currentImage,
      likeDislikeConfig: {
        enabled: likeDislikeEnabled
      },
      mqTwoColumnUp: mqTwoColumnUp,
      parentProductId: parentProductId,
      product: product,
      setProductImageEl: setProductImageEl
    })), prevImage !== currentImage &&
    /*#__PURE__*/
    React.createElement(OffscreenProductImage, {
      dislikeButtonConfig: dislikeButtonConfig,
      image: prevImage,
      likeDislikeConfig: {
        enabled: likeDislikeEnabled
      },
      loading: "lazy",
      mqTwoColumnUp: mqTwoColumnUp,
      parentProductId: parentProductId,
      product: _objectSpread2(_objectSpread2({}, product), {}, {
        name: ''
      })
    }), nextImage !== currentImage &&
    /*#__PURE__*/
    React.createElement(OffscreenProductImage, {
      dislikeButtonConfig: dislikeButtonConfig,
      image: nextImage,
      likeDislikeConfig: {
        enabled: likeDislikeEnabled
      },
      loading: "lazy",
      mqTwoColumnUp: mqTwoColumnUp,
      parentProductId: parentProductId,
      product: _objectSpread2(_objectSpread2({}, product), {}, {
        name: ''
      })
    }), images.length > 1 &&
    /*#__PURE__*/
    React.createElement(PreviousImageButton, {
      ariaLabel: "previous image",
      onClick: handlePreviousImageClicked,
      variant: "back"
    }), images.length > 1 &&
    /*#__PURE__*/
    React.createElement(NextImageButton, {
      ariaLabel: "next image",
      onClick: handleNextImageClicked,
      variant: "forward"
    }),
    /*#__PURE__*/
    React.createElement(Dots, null, images.map(function (image, index) {
      var selected = index === currentImageIndex;
      return (
        /*#__PURE__*/
        React.createElement(Dot, {
          "data-testid": "dot-".concat(index).concat(selected ? '-selected' : ''),
          key: "".concat(image, "-").concat(index),
          selected: selected
        })
      );
    }))))
  );
}

var ANIMATION_DURATION_MS = 300;
var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n    width: 100%;\n    height: 0;\n    padding-bottom: 100%;\n  "]))),
  Animated: styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n\n    ", "\n  "])), function (p) {
    return p.animation && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      animation:\n        ", "\n        ", "ms\n        ease-in-out;\n    "])), p.animation, ANIMATION_DURATION_MS);
  }),
  MainProductImage: styled(ProductImage)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    border-bottom: 1px solid ", ";\n  "])), grayLightM),
  OffscreenProductImage: styled(ProductImage)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: -100%;\n    height: 100%;\n    width: 100%;\n    visibility: hidden;\n  "]))),
  Dots: styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    position: absolute;\n    left: 50%;\n    bottom: 0.5rem;\n    transform: translateX(-50%);\n\n    display: grid;\n    grid-auto-flow: column;\n    grid-column-gap: 0.5rem;\n  "]))),
  Dot: styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    height: 0.5rem;\n    width: 0.5rem;\n\n    background-color: ", ";\n    border-radius: 50%;\n\n    ", "\n  "])), grayLightM, function (p) {
    return p.selected && "\n      background-color: ".concat(selectedM, ";\n    ");
  }),
  NextImageButton: styled(NavButton)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 50%;\n    right: 1rem;\n    transform: translateY(-50%);\n  "]))),
  PreviousImageButton: styled(NavButton)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 50%;\n    left: 1rem;\n    transform: translateY(-50%);\n  "])))
};
export default StackedProductImageCarousel;